const langMapping = {
  ar: "العربية",
  zh: "中文",
  en: "English",
  fr: "Français",
  de: "German",
  id: "Bahasa Indonesia",
  it: "Italiano",
  jp: "日本語",
  ko: "한국어",
  my: "Myanmasa",
  pt: "Português",
  es: "Español",
  vi: "Việtnam",
}

export default langMapping
